import React from "react";
import { storyblokEditable } from "@storyblok/react";
import Teaser from "./Teaser";
import MaterialsItem from "./Materials-item";

const Materials = ({ blok }) => {
    return (
        <section className="materials" {...storyblokEditable(blok)}>
            {blok.h2_subtitle && blok.h2_subtitle.map(title => (
                <Teaser key={title._uid} blok={title}/>
            ))}
            <div className="materials-container">
                {Object.keys(blok).map(key => {
                    if (key.startsWith("materials_item_")) {
                        return blok[key].map(item => (
                            <MaterialsItem key={item._uid} blok={item} />
                        ));
                    }
                    return null;
                })}
            </div>
        </section>
    );
};

export default Materials;

